






























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() pId!: number;

  dispatchType: string = "users/aiPlayerLog";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "添加事由", dataIndex: "cron_type_text" },
    { title: "权重", dataIndex: "weight" },
    { title: "权重变化", dataIndex: "diff" }
  ];

  mounted() {
    this.loadData({
      pid: this.pId
    });
  }
}
